export {
	default as SimpleNumber,
	ChangeIndicatedNumber,
} from './simple-number';
